import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import {  useAuthStore } from '../store/auth.store';
import { me } from '../services/auth-service';

export const useFetchMe = () => {
  const setUser = useAuthStore((s) => s.setUser);
  const clearAuth = useAuthStore((s) => s.clearAuth);
  const setLoadingMe = useAuthStore((s) => s.setLoadingMe);

  const query = useQuery({
    queryKey: ['auth-me'],
    queryFn: me,
    retry: false,
    staleTime: 1000 * 60 * 15,
  });

  useEffect(() => {
    if (query.isLoading || query.isFetching) {
      setLoadingMe(true);
    } else if (query.isSuccess && query.data) {
      setUser(query.data);
    } else if (query.isError) {
      clearAuth();
    }
  }, [query.isLoading, query.isFetching, query.isSuccess, query.isError, query.data, setUser, clearAuth, setLoadingMe]);

  return query;
};
